module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("批次取藥清單        ")]), _c('hr'), _c('form', {
    staticClass: "form-inline mb-2",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control mr-2 w-25",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥碼、料位號、學名或病歷號查詢"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/fetch-schedule/"),
      "data-path": "results",
      "pagination-path": "",
      "fields": _vm.fields,
      "per-page": 30,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  }), _c('button', {
    staticClass: "btn btn-danger btn-sm mt-2",
    on: {
      "click": _vm.deleteSchedule
    }
  }, [_vm._v("刪除選擇藥單")]), _c('hr'), _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "id": "batch-file-input"
    }
  }), _c('button', {
    staticClass: "btn btn-info btn-sm",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("上傳批次檔")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7ee1ed6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/FetchScheduleList.vue
// module id = 1544
// module chunks = 1